import React, { Component, PureComponent } from 'react'
import { List, Map, OrderedMap } from 'immutable'
import { connect } from 'react-redux'
import moment from 'moment'
import { Button, Icon, Popup, Loader, Dimmer } from 'semantic-ui-react'
import { SimpleForm } from '~/form'
import { ErrorAggregator } from '~/message'
import { createApproval, updateApproval, deleteApproval, runApprovalAction, adminApprove } from '../../../actions'

export function processApprovalInfo(approvals) {
  let activeApproval = approvals.reduce(
    (found, i) => (found ? found : i.getIn(['data', 'status'], 'pending') !== 'approved' ? i : false),
    false
  )
  let activeApprovalId = Map.isMap(activeApproval) ? activeApproval.get('id') : false

  let approvalGroups = approvals
    .reduce((groups, item) => {
      let order = item.get('order')
      return groups.set(order, groups.get(order, List()).push(item))
    }, OrderedMap())
    .sort((a, b) => (a.getIn([0, 'order'], 0) > b.getIn([0, 'order'], 0) ? 1 : -1))

  let activeApprovalGroupId = approvalGroups.reduce(
    (found, g, id) =>
      found
        ? found
        : g.reduce((isApproved, i) => (i.getIn(['data', 'status']) !== 'approved' ? false : isApproved), true) === false
        ? id
        : false,
    false
  )
  let activeApprovalGroup = approvalGroups.get(activeApprovalGroupId, List())

  return {
    activeApproval,
    activeApprovalId,
    approvalGroups,
    activeApprovalGroupId,
    activeApprovalGroup,
  }
}

function getGroupOptions(approvals) {
  let highestGroup = approvals.reduce(
    (highest, a) => (parseInt(a.get('order')) > highest ? parseInt(a.get('order')) : highest),
    0
  )
  let groups = []
  let counter = 0

  while (counter < highestGroup) {
    groups.push(counter + 1)
    counter++
  }

  let newGroup = highestGroup + 1
  let groupOptions = groups.map(group => ({ value: group, label: `Ryhmä: ${group}` }))
  groupOptions.push({
    value: newGroup,
    label: `Uusi ryhmä: ${newGroup}`,
  })
  return groupOptions
}

class ApprovalCreate extends Component {
  state = {
    open: false,
  }

  renderForm = () => {
    let { onCreate, project, interview, approvals } = this.props

    let options = [
      ...interview
        .get('people', List())
        .map(p => ({ value: `person_${p.get('id')}`, label: `Haastateltava (${p.getIn(['data', 'name'])})` }))
        .toArray(),
      ...project
        .get('contacts', List())
        .map(c => ({
          value: `contact_${c.get('id')}`,
          label: `Asiakas (${project.getIn(['organization', 'name'])} / ${c.get('name')})`,
        }))
        .toArray(),
    ]

    let groupOptions = getGroupOptions(approvals)
    let newGroup = groupOptions[groupOptions.length - 1].value

    let formFields = [
      {
        name: 'approval_target',
        type: 'radios',
        label: 'Hyväksyttäjä',
        options,
      },
      {
        name: 'order',
        type: 'radios',
        label: 'Ryhmä',
        options: groupOptions,
      },
    ]

    return (
      <SimpleForm
        fields={formFields}
        values={Map({ order: newGroup })}
        validation={{ approval_target: ['required'] }}
        submitText="Luo hyväksytys"
        onSubmit={values => onCreate(values).then(() => setTimeout(() => this.setState({ open: false }), 1))}
      />
    )
  }

  render() {
    let { open } = this.state

    return (
      <Popup
        trigger={
          <Button content="Lisää hyväksyttäjä" icon="plus" size="tiny" onClick={e => e.preventDefault()} color="blue" />
        }
        content={this.renderForm()}
        style={{ margin: 0, padding: 0, borderRadius: 0 }}
        on="click"
        open={open}
        onOpen={() => this.setState({ open: true })}
        onClose={() => this.setState({ open: false })}
        position="top left"
      />
    )
  }
}

class ApprovalEdit extends Component {
  state = {
    open: false,
    deleting: false,
    approving: false,
  }

  renderForm = () => {
    let { approvals, approval, onDelete, onAdminApprove, onEdit } = this.props
    let { open, deleting, approving } = this.state

    if (!open) return null

    let formFields = [
      {
        name: 'order',
        type: 'radios',
        label: 'Ryhmä',
        options: getGroupOptions(approvals),
      },
      {
        name: 'delete',
        type: 'render',
        render: () => {
          return (
            <div className="approve-list-item-action">
              {!deleting ? (
                <div className="approve-list-item-action-prompt">
                  <a
                    className="approve-list-item-action-prompt-button"
                    onClick={e => e.preventDefault() & this.setState({ deleting: true })}>
                    <Icon name="trash" />
                    Poista
                  </a>
                </div>
              ) : (
                <div className="approve-list-item-action-question">
                  <span>
                    <Icon name="trash" />
                    Haluatko varmasti poistaa?
                  </span>
                  <div className="approve-list-item-action-answer">
                    <a className="button-plain" onClick={e => e.preventDefault() & onDelete(approval)}>
                      Kyllä
                    </a>
                    {' / '}
                    <a className="button-plain" onClick={e => e.preventDefault() & this.setState({ deleting: false })}>
                      En
                    </a>
                  </div>
                </div>
              )}
            </div>
          )
        },
      },
      {
        name: 'finish',
        type: 'render',
        render: () => {
          if (approval.getIn(['data', 'status']) === 'approved') return null

          return (
            <div className="approve-list-item-action">
              {!approving ? (
                <div className="approve-list-item-action-prompt">
                  <a
                    className="approve-list-item-action-prompt-button"
                    onClick={e => e.preventDefault() & this.setState({ approving: true })}>
                    <Icon name="check" />
                    Merkitse hyväksytyksi
                  </a>
                </div>
              ) : (
                <div className="approve-list-item-action-question">
                  <span>
                    <Icon name="check" />
                    Haluatko varmasti hyväksyä?
                  </span>
                  <div className="approve-list-item-action-answer">
                    <a className="button-plain" onClick={e => e.preventDefault() & onAdminApprove(approval)}>
                      Kyllä
                    </a>
                    {' / '}
                    <a className="button-plain" onClick={e => e.preventDefault() & this.setState({ approving: false })}>
                      En
                    </a>
                  </div>
                </div>
              )}
            </div>
          )
        },
      },
    ]

    return (
      <SimpleForm
        fields={formFields}
        values={approval}
        validation={{ order: ['required'] }}
        submitText="Päivitä"
        onSubmit={values => onEdit(values).then(() => setTimeout(() => this.setState({ open: false }), 1))}
      />
    )
  }

  render() {
    let { open } = this.state

    return (
      <Popup
        trigger={
          <button className="approval-list-item-edit" onClick={e => e.preventDefault()}>
            <Icon name="edit" />
            Muokkaa
          </button>
        }
        content={this.renderForm()}
        style={{ margin: 0, padding: 0, borderRadius: 0 }}
        on="click"
        open={open}
        onOpen={() => this.setState({ open: true })}
        onClose={() => this.setState({ open: false })}
        position="top left"
      />
    )
  }
}

class ApprovalAction extends Component {
  state = {
    open: false,
    message: '',
  }

  renderPrompt = () => {
    let { onAction } = this.props
    let { message } = this.state

    return (
      <div className="approve-action-prompt">
        <div className="approve-action-prompt-message">
          <textarea
            name="action-message"
            value={message}
            placeholder="Kirjoita viestisi tähän..."
            onChange={e => this.setState({ message: e.target.value })}
          />
        </div>
        <div className="approve-action-prompt-buttons">
          <b>Oletko varma?</b>
          <button
            onClick={e => e.preventDefault() & onAction(message) & this.setState({ open: false })}
            className="button-plain">
            Kyllä
          </button>
          <button onClick={e => e.preventDefault() & this.setState({ open: false })} className="button-plain">
            Ei
          </button>
        </div>
      </div>
    )
  }

  render() {
    let { approval } = this.props
    let { open } = this.state
    let status = approval.getIn(['data', 'status'], 'pending')

    let action = (
      <button className="approve-action" onClick={e => e.preventDefault()}>
        <Icon name="play" /> Lähetä muistutus
      </button>
    )

    if (status === 'pending')
      action = (
        <button className="approve-action" onClick={e => e.preventDefault()}>
          <Icon name="play" /> Aloita hyväksytys
        </button>
      )

    if (status === 'commented')
      action = (
        <button className="approve-action" onClick={e => e.preventDefault()}>
          <Icon name="play" /> Lähetä korjaukset
        </button>
      )

    if (status === 'approved')
      action = (
        <button className="approve-action" onClick={e => e.preventDefault()}>
          <Icon name="play" /> Lähetä korjaukset
        </button>
      )

    if (!action) return false

    return (
      <div className="approve-action">
        <Popup
          trigger={action}
          content={this.renderPrompt()}
          style={{ margin: 0, padding: 0, borderRadius: 0 }}
          on="click"
          open={open}
          onOpen={() => this.setState({ open: true })}
          onClose={() => this.setState({ open: false })}
          position="top left"
        />
      </div>
    )
  }
}

class ApprovalGroupAction extends Component {
  state = {
    open: false,
  }

  runGroupActions = () => {
    let { items } = this.props
    let { loading, onAction } = this.props
    if (loading) return

    onAction(
      items
        .filter(i => i.getIn(['data', 'status'], 'pending') === 'pending')
        .map(i => i.get('id'))
        .toArray()
    )
    this.setState({ open: false })
  }

  renderPrompt = () => {
    return (
      <div className="approve-action-prompt">
        <div className="approve-action-prompt-buttons">
          <b>Oletko varma?</b>
          <div>
            <button
              onClick={e => e.preventDefault() & this.runGroupActions() & this.setState({ open: false })}
              className="button-plain">
              Kyllä
            </button>
            <button onClick={e => e.preventDefault() & this.setState({ open: false })} className="button-plain">
              Ei
            </button>
          </div>
        </div>
      </div>
    )
  }

  render() {
    let { open } = this.state
    let { items, loading } = this.props

    items = items.filter(i => i.getIn(['data', 'status'], 'pending') === 'pending')
    if (items.size < 2) return null

    let action = loading ? (
      <span className="approve-action">
        <Icon name="spinner" loading /> Ladataan...
      </span>
    ) : (
      <button className="approve-action" onClick={e => e.preventDefault()}>
        <Icon name="play" /> Aloita koko ryhmä
      </button>
    )

    return (
      <div className="approve-group-action-wrapper">
        <Popup
          trigger={action}
          content={this.renderPrompt()}
          style={{ margin: 0, padding: 0, borderRadius: 0 }}
          on="click"
          open={open}
          onOpen={() => this.setState({ open: true })}
          onClose={() => this.setState({ open: false })}
          position="top left"
        />
      </div>
    )
  }
}

function ApprovalActionStatus({ status }) {
  let statusIcon = {
    success: 'check',
    error: 'warning sign',
  }

  return (
    <span className={`approval-action-status approval-action-status--${status}`}>
      <Icon name={statusIcon[status] || 'info'} />
    </span>
  )
}

class MaterialApproval extends PureComponent {
  render() {
    let {
      interview,
      project,
      items: approvals,
      approvalGroups,
      creating,
      activeApproval,
      activeApprovalId,
      activeApprovalGroupId,
      activeApprovalGroup,
      dispatch,
      createLoading,
      createError,
      updateLoading,
      updateError,
      deleteLoading,
      deleteError,
      actionLoading,
      actionError,
      actionStatus,
      viewOnly = false,
    } = this.props

    let interviewId = interview.get('id')
    let projectId = project.get('id')

    let errorAggregatorItems = {
      ApprovalCreateError: createError,
      ApprovalUpdateError: updateError,
      ApprovalDeleteError: deleteError,
      ApprovalActionError: actionError,
    }

    let loading = createLoading || updateLoading || deleteLoading || actionLoading

    return (
      <div className="approval">
        {!viewOnly ? (
          <div className="approval-top">
            <ApprovalCreate
              interview={interview}
              project={project}
              approvals={approvals}
              onCreate={values =>
                dispatch(createApproval(projectId, interviewId, values.get('approval_target'), values.get('order')))
              }
            />
          </div>
        ) : null}
        {approvalGroups.size ? (
          <div className="approval-list">
            {approvalGroups
              .map((items, group) => {
                return (
                  <div className="approval-list-group" key={group}>
                    <div className="approval-list-group-title">
                      <div className="approval-list-group-title-text">{`Ryhmä: ${group}`}</div>
                      <div className="approval-list-group-title-action">
                        {group === activeApprovalGroupId ? (
                          <ApprovalGroupAction
                            {...this.props}
                            loading={actionLoading}
                            items={items}
                            onAction={ids => dispatch(runApprovalAction(projectId, interviewId, ids))}
                          />
                        ) : null}
                      </div>
                    </div>
                    <div className="approval-list-group-items">
                      {items.map((a, key) => {
                        let isActive = a.get('order') === activeApprovalGroupId

                        let title = '(Hyväksyjä puuttuu)'
                        if (a.get('contact')) {
                          title = `Asiakas: ${project.getIn(['organization', 'name'])} / ${a.getIn(
                            ['contact', 'name'],
                            ''
                          )}`
                        } else if (a.get('person')) {
                          title = `Haastateltava: ${a.getIn(['person', 'data', 'name'], '')}`
                        }

                        let status = a.getIn(['data', 'status'], 'pending')
                        let itemActionStatus = actionStatus.get(a.get('id'), false)

                        let lastAction = a.getIn(['data', 'last_action'], false)
                        if (lastAction) lastAction = moment(lastAction).format('DD.MM.YYYY - HH.mm')

                        let statusColors = {
                          pending: 'grey',
                          sent: 'yellow',
                          opened: 'blue',
                          commented: 'red',
                          approved: 'green',
                        }

                        let statusLabels = {
                          pending: 'Odottaa',
                          sent: 'Lähetetty',
                          opened: 'Avattu',
                          commented: 'Ei hyväksytty',
                          approved: 'Hyväksytty',
                        }

                        return (
                          <div className="approval-list-item" key={key}>
                            <div className="approval-list-item-order">
                              <span>{a.get('order')}</span>
                            </div>
                            <div className="approval-list-item-name">
                              <a
                                href={`${process.env.APPROVAL_URL}/hyvaksytys/${a.get('id')}?${
                                  status === 'commented' ? 'view=admin' : 'preview=1'
                                }`}
                                target="_blank">
                                {title}
                              </a>
                            </div>
                            <div className="approval-list-item-info">
                              <div>
                                <span className={`tags-item tags-item--${statusColors[status]}`}>
                                  {statusLabels[status] || status}
                                </span>
                                {lastAction ? <span>{lastAction}</span> : null}
                                <ApprovalEdit
                                  approval={a}
                                  approvals={approvals}
                                  onEdit={values =>
                                    dispatch(updateApproval(projectId, interviewId, a.get('id'), values))
                                  }
                                  onDelete={values => dispatch(deleteApproval(projectId, interviewId, a.get('id')))}
                                  onAdminApprove={values => dispatch(adminApprove(projectId, interviewId, a.get('id')))}
                                />
                              </div>
                              {itemActionStatus ? (
                                <ApprovalActionStatus status={itemActionStatus} />
                              ) : isActive ? (
                                <ApprovalAction
                                  approval={a}
                                  onAction={(message = '') =>
                                    dispatch(runApprovalAction(projectId, interviewId, [a.get('id')], message))
                                  }
                                />
                              ) : null}
                            </div>
                          </div>
                        )
                      })}
                    </div>
                  </div>
                )
              })
              .toArray()}
          </div>
        ) : (
          <div className="approval-list-empty">Hyväksytyksiä ei ole luotu.</div>
        )}
        <ErrorAggregator items={errorAggregatorItems} />
        {loading ? (
          <div className="approval-loading">
            <Dimmer active inverted>
              <Loader inverted />
            </Dimmer>
          </div>
        ) : null}
      </div>
    )
  }
}

export default connect(state => ({
  createLoading: state.projectCreateApprovalLoading,
  createError: state.projectCreateApprovalError,
  updateLoading: state.projectUpdateApprovalLoading,
  updateError: state.projectUpdateApprovalError,
  deleteLoading: state.projectDeleteApprovalLoading,
  deleteError: state.projectDeleteApprovalError,
  actionLoading: state.projectRunApprovalActionLoading,
  actionError: state.projectRunApprovalActionError,
  actionStatus: state.projectApprovalActionStatus,
}))(MaterialApproval)
